import { VertexEvent } from './VertexEvent';
export class RightVertexEvent extends VertexEvent {
    constructor(p) {
        super(p);
    }
}
//# sourceMappingURL=RightVertexEvent.js.map